require('./dist/ui-bootstrap-tpls');

module.exports = 'ui.bootstrap';



//////////////////
// WEBPACK FOOTER
// ../node_modules/angular-ui-bootstrap/index.js
// module id = 214
// module chunks = 0